import React from "react";
import type {MetaFunction} from "@remix-run/node";
import {Facebook, Twitter, Telegram, Instagram, BettorSignals} from "@bettorsignals/assets";
import type {LinkTreeButtonProps} from "@bettorsignals/ui";
import {WithBackgroundGradient, LinkTreeButton} from "@bettorsignals/ui";
import {LinkTo} from "~/utils/LinkTo";

export const meta: MetaFunction = () => {
    return {
        title: "Choose Your Channel | BettorSignals.com",
        description: "BettorSignals' social links."
    };
};

const CHANNELS: LinkTreeButtonProps[] = [
    {
        href: LinkTo.homePage(),
        name: "Web Page",
        Icon: <BettorSignals className="h-14 w-14" />,
        classNames: "border-bs-pink bg-[#fb9dc81a] hover:bg-bs-pink-light"
    },
    {
        href: LinkTo.facebookGroup(),
        name: "Facebook Group",
        Icon: <Facebook className="h-6 w-6 fill-facebook-blue" />,
        classNames: "border-[#3568f04d] bg-[#3568f01a] hover:bg-[#3568f04d]"
    },
    {
        href: LinkTo.telegramChannel(),
        name: "Telegram Channel",
        Icon: <Telegram className="h-6 w-6 fill-telegram-gradient" />,
        classNames: "border-[#2aabee4d] bg-[#2aabee1a] hover:bg-[#2aabee4d]"
    },
    {
        href: LinkTo.twitterPage(),
        name: "Twitter Profile",
        Icon: <Twitter className="h-6 w-6 fill-twitter-blue" />,
        classNames: "border-[#1da1f24d] bg-[#1da1f21a] hover:bg-[#1da1f24d]"
    },
    {
        href: LinkTo.instagramPage(),
        name: "Instagram Profile",
        Icon: <Instagram className="h-6 w-6 fill-black" />,
        classNames: "border-[#5b51d84d] bg-[#5b51d81a] hover:bg-[#5b51d84d]"
    }
];

export default function LinkTree() {
    return (
        <WithBackgroundGradient>
            <div className="relative mx-auto flex h-screen w-screen max-w-bs flex-col items-center px-4 py-10 pb-20">
                <div className="pb-10 text-center">
                    <h1 className="animate-pulse text-4xl font-bold">Choose Your Channel 👇</h1>
                    <span className="text-sm font-normal italic">
                        Where do you want to receive daily betting tips?
                    </span>
                </div>

                <main className="flex w-64 flex-col items-center justify-center gap-6">
                    {CHANNELS.map((props) => (
                        <LinkTreeButton key={props.name} {...props} />
                    ))}
                </main>
            </div>
        </WithBackgroundGradient>
    );
}
